export default __webpack_public_path__ + "static/media/logo-full.89c9409d.png";